import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { UserContext } from '../context/UserContext';
import { getLoanDetails } from '../service/loan';

export const useLoanDetails = () => {
  const [loanLoading, setLoanLoading] = useState(true);
  const [loan, setLoan] = useState();
  const { setLoading } = useContext(UserContext);
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    const loadLoan = async (id) => {
      try {
        const { data } = await getLoanDetails(id);
        setLoan(data);
      } catch (e) {
        console.log('error', e);
      } finally {
        setLoanLoading(false);
        setLoading(false);
      }
    };

    loadLoan(params.id);
  }, [params.id]);

  return {
    loan,
    loanLoading,
  };
};
